<script lang="ts" setup>
// import { ref } from 'vue';
// import dayjs from 'dayjs';
// import { fetch } from '@/plugins/fetch';
// import Countdown from '@/components/Countdown';
// import { OPENING_DATE } from '@/constants';

defineOptions({
  name: 'SummitBanner',
});

// const countingEnd = ref(false);
// const targetTimestamp = ref(0);
// let offset = 0;

// const getServerTime = async () => {
//   const { isSuccess, data } = await fetch('/summit/2023/index/getTime', { method: 'get' });

//   let clientNowTimestamp = Date.now();

//   if (isSuccess) {
//     offset = data.nowTimestamp - clientNowTimestamp;
//     clientNowTimestamp = data.nowTimestamp;
//   }

//   targetTimestamp.value = dayjs(OPENING_DATE).valueOf() - clientNowTimestamp;
// }

// const getNowTimestamp = () => Date.now() + offset;

// getServerTime();
</script>

<template>
  <section class="page-home-banner relative z-0 h-[854px] w-full pt-[364px] after:absolute after:top-0 after:block after:h-full after:w-full after:content-empty after:-z-2 before:absolute before:top-0 before:block before:h-full before:w-full before:bg-center-top before:bg-no-repeat before:content-empty before:-z-1">
    <h2 class="h-[32px] text-center text-24px text-[#00479D] font-normal leading-[32px]">OPENATOM GLOBAL OPENSOURCE SUMMIT</h2>
    <div class="mt-16px h-48px text-center text-32px text-#0068B7 font-medium leading-48px tracking-14px">&lt;/开源赋能 普惠未来.></div>
    <div class="mt-16px h-32px text-center text-24px text-#2D2D2D font-normal leading-32px tracking-3.5px">2023.6.11-13 中国·北京</div>
    <div class="mt-16px h-32px text-center text-24px text-#036EB8 font-normal leading-32px">北京北人亦创国际会展中心</div>
    <!-- <div class="mt-8px text-center text-40px font-normal leading-60px text-#036EB8" v-if="!countingEnd && targetTimestamp > 0">
      距离峰会开幕式<br>还有
      <Countdown :time="targetTimestamp" :now="getNowTimestamp" v-slot="{ days, hours, minutes, seconds }" @end="countingEnd = true">
        <template v-if="days > 0">
          <span class="inline-block align-bottom text-56px font-medium text-#32A0FF">{{ days }}</span> 天
        </template>
        <template v-else-if="hours > 0">
          <span class="inline-block align-bottom text-56px font-medium text-#32A0FF">{{ hours }}</span> 小时
        </template>
        <template v-else-if="minutes > 0">
          <span class="inline-block align-bottom text-56px font-medium text-#32A0FF">{{ minutes }}</span> 分钟
        </template>
        <template v-else>
          <span class="inline-block align-bottom text-56px font-medium text-#32A0FF">{{ seconds }}</span> 秒
        </template>
      </Countdown>
    </div> -->
    <a href="https://gongyi.cctv.com/special/opensource/index.shtml" target="_blank" class="mx-auto mt-40px block h-60px w-236px flex cursor-pointer items-center justify-center no-underline">
      <span class="goto block h-full w-full bg-contain bg-no-repeat"></span>
    </a>
    <div class="mx-auto mt-148px w-620px text-center text-16px text-#747678 font-normal leading-24px">
      主办单位：2023全球数字经济大会组委会<br>
      承办单位：开放原子开源基金会 北京市经济和信息化局 北京经济技术开发区管理委员会
    </div>
  </section>
</template>

<style lang="scss" scoped>
.page-home-banner {
  &::before {
    background-image: url(https://res.oafimg.cn/-/be8e48d2b2f0ecd2/summit-banner.png);
    background-size: 1920px 100%;
  }

  &::after {
    background: #c4e7f0;
    background-image: linear-gradient(180deg, #c4e7f0 0%, #caeaf2 21%, #e2f3f8 53%, #fff 77%, #fff 100%);
  }

  .goto {
    background-image: url(@/assets/live-sprites.png);
    background-position: 0 0;
    background-size: 100%;

    &:hover {
      background-position: 0 -60px;
    }
  }
}
</style>
